import React, { useEffect, useState, useCallback } from "react";
import { useForm,Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FormError } from "../../components/FormError";
import NumberField  from "../../components/admin/NumberField";
import SelectBox from "../../components/admin/SelectBox";
import  defaultConfig  from "../../config/Config";
import OrderProducts from "../../components/admin/orders/OrderProducts";
import { ToSelectOption } from "../../Utils/utils/CommanFnc";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import { getAllState } from "../../slices/InitialDataSlice";
import { getUserByType } from "../../slices/UserSlice";
import { createOrder, resetApiStatus } from "../../slices/OrdersSlice";
import { MessageModel } from "../../components/MessageModel";
import { Loading } from "../../components/Loading";
import { useNavigate } from "react-router-dom";
export function CreateOrder () {
    const [ product, setProduct] = useState([]);
    const [assignedState, setAssignedState] = useState([]);
    const [userTypes, setUserTypes] = useState([]);
    const [selectedUserType, setSelectedUserType] = useState('');
    const authData = useSelector( (state) => state.auth.authData );
    const allStates = useSelector( (state) => state.initialData.StateList );
    const ordersSlice = useSelector( (state) => state.orders );
    const { usersByType } = useSelector((state) => state.users);
    const [totalAmount, setTotalAmount] = useState(0);
    const [vendorList, setVendorList] = useState([]);
    const [productCount, setProductCount] = useState(1);
    const formSchema = Yup.object().shape({
      vendorType: Yup.string().required("Please select a vendor type"),
      assignedState: Yup.string().required("Please select state"),
      orderFrom: Yup.string().required("Please select ordred from"),
    });
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        setValue,
        getValues,
        trigger,
        control,    
        formState: { errors },
    } = useForm({
      mode: "onBlur",
      resolver: yupResolver(formSchema),
    });
    
    useEffect(() => {
      document.addEventListener( "calculate-total-amount", calculateTotalAmount)
    },[])

    useEffect(() => {
      setProduct([{
          productId: '',
          quantity: 0
      }]);

      dispatch(getAllState());
      setUserTypes(
            ToSelectOption(
                  defaultConfig.orderUserType, 
                  { 
                    value:"value", 
                    label:"label" 
                  }
            )
      )
    }, [dispatch])

    useEffect( () => {
      const assignedStateIds = authData.user.assignState;
      setAssignedState( () => {
          const states = findAssignedState(allStates, assignedStateIds);
          return  ToSelectOption(
            states,
            {
              value:"_id",
              label: 'name'
            }
          )
      } );
    }, [allStates, authData])

    useEffect (() => { 
      let list = []
      if(typeof usersByType !== "undefined"){
        list = usersByType?.map( ({userDetails, _id: userID}) => {
          return {
              value: userID,
              label: userDetails.shopName
          }
        })
      }
      setVendorList(list)
    },[setVendorList, usersByType]);

    function findAssignedState(allStates, assignedStateIds) {
      if(!assignedStateIds || (assignedStateIds.length === 0)) {
        return allStates;
      }
      return allStates.filter( (state) => assignedStateIds.indexOf(state._id) > -1 );
    }

    function getVendor(stateId, callback) {
      if(selectedUserType && stateId) {
        dispatch(getUserByType({userType: selectedUserType, stateId: stateId}))
      }
      callback(stateId)
    }

    function addProductList () {
        setProduct([
            ...product,
            {
              productId: '',
              quantity: 0
          }
        ])
        setProductCount(product+1)
    }

    function removeProduct(index) {
      let prd = [...product];
      if(prd.length > 1) {
        setProduct((prev) => {
          prd.splice(index, 1);
          setProductCount(prd.length)
          return prd
        })
      }
      
    }

    const calculateTotalAmount = useCallback( function (){
      const products = getValues('product');
      const total = products?.reduce( (current, next) => {
          return parseFloat(current) + parseFloat(next.totalAmount || 0);
      }, 0)
      if(total){
        setValue('totalAmount', total);
        setTotalAmount(total);
      }
    } ,[getValues, setValue]);

    function onSubmit(dataToSubmit) {
      dispatch(createOrder(dataToSubmit));
    }

    function onCancel() {
      navigate('/orders')
    }

  return (
        <div className="row">
          <div className="col-md-12 col-lg-12">
            <div className="card payment-card">
              <div className="card-header">
                <h4 className="card-title">{ "Create Order"}</h4>
              </div>
              <hr/>
              <div className="card-body">
                <form onSubmit={handleSubmit(onSubmit)}>
                  <input {...register("id")} type="hidden" />
                  <div className="formDiv">
                    <div className="row">
                      <div className="col-4">
                        <div className="form-group mb-3">
                          <label
                            htmlFor="card-number"
                            className={`input-label ${errors.vendorType && "error"}`}
                          >
                            Vendor Type
                          </label>
                          <Controller
                            control={control}
                            name="vendorType"
                            render={({ field: { value, onChange } }) => (
                              <SelectBox
                                options={userTypes}
                                isClearable={true}
                                onChange={(opt) => {  
                                  onChange(opt?.value); 
                                  setSelectedUserType(opt?.value)
                                }}
                                value={userTypes.find(
                                  (option) => option.value === value
                                )}
                              />
                            )}
                          />
                          
                          {errors.vendorType && (
                            <FormError message={errors.vendorType.message} />
                          )}
                        </div>
                      </div>                                                                                                            
                      
                      <div className="col-4">
                        <div className="form-group mb-3">
                          <label
                            htmlFor="card-number"
                            className={`input-label ${errors.vendorType && "error"}`}
                          >
                            States
                          </label>
                          <Controller
                            control={control}
                            name="assignedState"
                            render={({ field: { value, onChange } }) => (
                              <SelectBox
                                options={assignedState}
                                isClearable={true}
                                onChange={(opt) => getVendor(opt?.value, onChange)}
                                value={assignedState?.find(
                                  (option) => option.value === value
                                )}
                              />
                            )}
                          />
                          
                          {errors.assignedState && (
                            <FormError message={errors.assignedState.message} />
                          )}
                        </div>
                      </div>
                      
                      <div className="col-4">
                        <div className="form-group mb-3">
                          <label
                            htmlFor="card-number"
                            className={`input-label ${errors.orderFrom && "error"}`}
                          >
                            Order From
                          </label>
                          <Controller
                            control={control}
                            name="orderFrom"
                            render={({ field: { value, onChange } }) => (
                              <SelectBox
                                options={vendorList}
                                isClearable={true}
                                onChange={(opt) => onChange(opt?.value)}
                                value={vendorList?.find(
                                  (option) => option.value === value
                                )}
                              />
                            )}
                          />
                          {errors.orderFrom && (
                            <FormError message={errors.orderFrom.message} />
                          )}
                        </div>
                      </div>
    
                      <div className="col-4">
                        <div className="form-group mb-3">
                          <label
                            htmlFor="card-number"
                            className={`d-block ${errors.totalAmount && "error"}`}
                          >
                            Total Amount
                          </label>
                          <NumberField 
                            readOnly="readonly" 
                            placeholder="Product Price" 
                            setValue = { setValue } 
                            control = {control} 
                            name = {`totalAmount`} 
                            value = {totalAmount} 
                            className='input-txt form-control'/> 
                             {errors.startDate && (
                            <FormError message={errors.startDate.message} />
                          )}
                        </div>
                      </div>
                    </div>
                    
                    <div className="col-sm-12 border p-0">
                        <h4 className="bg-light font-weight-bolder  text-dark p-3 mb-3 border-bottom"> Products </h4> 
                        <div id="productsList" className="col-sm-12">
                          {
                            product.map( (item, key) => {
                              return  <OrderProducts 
                                        key={ key }
                                        index={ key }
                                        errors 
                                        setValue = { setValue }
                                        getValues = { getValues }
                                        control = { control }
                                        addProductList = { addProductList }
                                        removeProduct = { removeProduct }
                                        productCount = {productCount}
                                        register = { register }
                                      />
                           })
                          }
                      </div>                        
                    </div>
                  </div>
                  <div className="col-12 mt-5 mb-3 text-right">
                    <button type="submit" className="btn btn-outline-success btn-lg mx-2">
                      Submit
                    </button>
                    <button onClick={ onCancel } type="button" className="btn btn-outline-danger btn-lg mx-2">
                      Cancel
                    </button>
                  </div>
                </form>
              </div>
              
            </div>
          </div>
          {ordersSlice.loading === true?<Loading/>:"" }
          {ordersSlice.message? 
            <MessageModel
              btnEvent={ ()=>{
                dispatch(resetApiStatus()) 
                if(ordersSlice.success) 
                  navigate("/orders")
              } }
              success={ordersSlice.success}
              message={ordersSlice.message}
            />
          :""}
        </div>
  );

}